import * as z from 'zod/mini';
export function recordSchema(keys, schema) {
    const props = keys.reduce((acc, key) => {
        acc[key] = schema;
        return acc;
    }, {});
    return z.object(props);
}
//# sourceMappingURL=recordSchema.js.map